import { default as _91token_93FpEqqL24WIMeta } from "/vercel/path0/pages/comprovante/[token].vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as index83khfESepCMeta } from "/vercel/path0/pages/integration/[integrationSlug]/index.vue?macro=true";
import { default as intentionUGme25aSsmMeta } from "/vercel/path0/pages/intention.vue?macro=true";
import { default as indexDlLj0wGI8VMeta } from "/vercel/path0/pages/questions/[questionSlug]/index.vue?macro=true";
import { default as resultWJ6OFk0y2uMeta } from "/vercel/path0/pages/questions/result.vue?macro=true";
export default [
  {
    name: "comprovante-token",
    path: "/comprovante/:token()",
    meta: _91token_93FpEqqL24WIMeta || {},
    component: () => import("/vercel/path0/pages/comprovante/[token].vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "integration-integrationSlug",
    path: "/integration/:integrationSlug()",
    meta: index83khfESepCMeta || {},
    component: () => import("/vercel/path0/pages/integration/[integrationSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "intention",
    path: "/intention",
    meta: intentionUGme25aSsmMeta || {},
    component: () => import("/vercel/path0/pages/intention.vue").then(m => m.default || m)
  },
  {
    name: "questions-questionSlug",
    path: "/questions/:questionSlug()",
    meta: indexDlLj0wGI8VMeta || {},
    component: () => import("/vercel/path0/pages/questions/[questionSlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "questions-result",
    path: "/questions/result",
    meta: resultWJ6OFk0y2uMeta || {},
    component: () => import("/vercel/path0/pages/questions/result.vue").then(m => m.default || m)
  }
]